import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const OvMenu = styled.div`
  width: fit-content;
  cursor: pointer;

  &:disabled {
    cursor: auto;
  }
`
export const StatusWrapper = styled.div`
  min-width: 125px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`
export const TableInfo = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 12.5px 0;
  white-space: nowrap;

  span {
    margin-top: ${theme.spacing.xs};
    font-size: ${theme.typography.sizes.xs};
    color: ${theme.colors.neutral.light};
  }

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    margin-right: ${theme.spacing.xm};
  }
`
export const FabInfo = styled.div`
  width: 100%;
`

export const CellItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
`

export const UnavailableInfo = styled.div`
  color: ${theme.colors.neutral.mediumhover};
  font-size: ${theme.typography.sizes.xs};
`
